interface SectionProps
  extends Omit<React.HTMLAttributes<HTMLElement>, "title"> {
  title: React.ReactNode;
  description?: React.ReactNode;
  rightContent?: React.ReactNode;
}

export function Section(props: React.PropsWithChildren<SectionProps>) {
  const { title, description, rightContent, children, ...rest } = props;
  return (
    <section {...rest}>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
          <p className="text-gray-600">{description}</p>
        </div>
        {rightContent}
      </div>

      {children}
    </section>
  );
}
